<template>
  <div>
    <Table
      :key="tableRenderKey"
      :data="dataSource"
      :show-summary="showSummary"
      :summary-method="handleSummaryMethod"
      @sort-change="handleSortChange"
    >
      <DynamicColumn
        v-for="item in columns"
        :key="item.key"
        :column="item"
        @filter-change="handleDynamicColumnChange"
      >
        <template v-slot:column="data">
          <slot
            name="column"
            :data="data.data"
          >
            {{ data.data.value || '-' }}
          </slot>
        </template>
      </DynamicColumn>
    </Table>

    <Pagination
      class="pagination"
      layout="total, sizes, prev, pager, next"
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizes"
      :total="total"
      v-on="$listeners"   
    />
  </div>
</template>

<script>
import { Table, Pagination } from 'element-ui';

import DynamicColumn from './components/Column/Index';

export default {
  components: {
    Table,
    Pagination,

    DynamicColumn,
  },

  inheritAttrs: false,

  props: {
    dataSource: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },

    columns: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },

    summary: {
      type: Object,
      default: null,
    },

    summaryTip: {
      type: String,
      default: '',
    },

    page: {
      type: Number,
      default: 1,
    },

    pageSize: {
      type: Number,
      default: 10,
    },

    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50, 100];
      },
    },

    total: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      tableRenderKey: 0,
    };
  },

  computed: {
    showSummary() {
      return Boolean(this.summary);
    },
  },

  watch: {
    columns: {
      deep: true,
      handler() {
        this.tableRenderKey += 1;
      },
    },
  },

  methods: {
    // 获取统计信息
    handleSummaryMethod({ columns, data }) {
      const sums = [];

      if (!this.summary) return sums;

      columns.forEach((column, index) => {
        const value = this.summary[column.property];
        if (index === 0) {
          if (this.summaryTip) {
            sums.push(this.summaryTip);
          } else {
            sums.push('汇总');
          }
          return;
        }

        if (value === 0 || value === undefined || value === '') {
          sums.push('-');
        } else {
          sums.push(value);
        }
      });

      return sums;
    },

    // 获取排序信息
    handleSortChange({ column, order, prop }) {
      if (order) {
        const ord = order === 'ascending' ? 'asc' : 'desc';
        this.$emit('sort-change', `${prop} ${ord}`);
      } else {
        this.$emit('sort-change', '');
      }
    },

    // 获取过滤信息
    handleDynamicColumnChange(filter) {
      this.$emit('filter-change', filter);
    },
  },
};
</script>

<style lang="less" scoped>
.pagination {
  margin-top: 20px;
  float: right;
}
</style>
